'use client';

import React from 'react';
import LegalDocumentBody from '@/components/LegalDocumentBody';

export default function AIUsageGuidelinesContent() {
  return <LegalDocumentBody pageId="aiUsage" />;
}
